import { createStore } from "vuex";
import auth from "./modules/auth";
import helpers from "./modules/helpers";
import courses from "./modules/courses";
import lecturerCourses from "./modules/lecturerCourses";
import media from "./modules/media";
import authUser from "./modules/authUser";
import lastVideos from "./modules/lastVideos";
import slides from "./modules/slides";
import notes from "./modules/notes";
import certificates from "./modules/certificates";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    helpers,
    courses,
    lecturerCourses,
    media,
    authUser,
    lastVideos,
    slides,
    notes,
    certificates,
  },
});
